const DEV_HOSTNAME = 'peppermayo-dev.myshopify.com';
const PROD_HOSTNAME = 'pmayo.myshopify.com';
const PROD_HOSTNAME_US = 'pmayo-us.myshopify.com';
const PROD_HOSTNAME_NZ = 'pmayo-nz.myshopify.com';

// Details for Storefront API.
const storefrontAccessToken = {
    dev: '3ade402fff414ba954d84bab900d5240',
    prod: 'f5785de3897064494ee626e805463db8',
    prod_us: 'acffe7b5c9a08acf0d4d15338990732f',
    prod_nz: '35000a0baf0d216284bc22210e6e0a18'
};

function getAccessToken() {
    switch(Shopify.shop) {
        case PROD_HOSTNAME:
          return storefrontAccessToken.prod;
        case PROD_HOSTNAME_US:
          return storefrontAccessToken.prod_us;
        case PROD_HOSTNAME_NZ:
          return storefrontAccessToken.prod_nz;
        default:
          return storefrontAccessToken.dev;
    }
}

export const storefrontRequestConfig = {
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': getAccessToken()
    }
};

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

// Middleware integrations

const onionUrl = {
    dev: `https://shopifyonionnavapp-dev.testarc.com.au/api/2020-09/products?shop=${DEV_HOSTNAME}`,
    prod: `https://shopifyonionnavapp.testarc.com.au/api/2020-09/products?shop=${PROD_HOSTNAME}`,
    prod_us: `https://shopifyonionnavapp.testarc.com.au/api/2020-09/products?shop=${PROD_HOSTNAME_US}`,
    prod_nz: `https://shopifyonionnavapp.testarc.com.au/api/2020-09/products?shop=${PROD_HOSTNAME_NZ}`
};

export function getOnionUrl() {
    switch(Shopify.shop) {
        case PROD_HOSTNAME:
          return onionUrl.prod;
        case PROD_HOSTNAME_US:
          return onionUrl.prod_us;
        case PROD_HOSTNAME_NZ:
          return onionUrl.prod_nz;
        default:
          return onionUrl.dev;
    }
}


